export const useStringFunctions = () => {
    /**
     *
     * @description Check to see if a string is functionally empty
     * @param test string to check
     * @param includeWhitespace if true, a non-empty string that only contains whitespace will be considered empty
     * @returns true if the string is empty
     */
    const isEmptyString = (test, includeWhitespace = false) => {
        if (test === null || test === undefined) {
            return true;
        }
        if (typeof test !== 'string') {
            throw new Error(`Error: '${test}' is type ${typeof test}, expected instance of string, null, or undefined`);
        }
        if (includeWhitespace && test.match(/^\s*$/)) {
            return true;
        }
        return test === '' || test.length === 0;
    };
    /**
     *
     * @description Compare whether two strings are equal
     * @param a first test string
     * @param b second test string
     * @param ignoreCase if true, case will be ignored when comparing. Eg a: 'Cat', b: 'cat' will return true
     * @param allowFalsy if true a: null, b: undefined will be considered equal
     * @returns true if strings are equal
     */
    const areEqual = (a, b, ignoreCase = false, allowFalsy = false) => {
        if (ignoreCase) {
            return a.toLocaleLowerCase() === b.toLocaleLowerCase();
        }
        if (allowFalsy && isEmptyString(a) && isEmptyString(b)) {
            return true;
        }
        return a === b;
    };
    return { areEqual, isEmptyString };
};
